import type { FaireProductEntity } from "../../entity_types/product";

export const p_zsvbcaz482: FaireProductEntity = {
  token: "p_zsvbcaz482",
  type: "product",
  name: "Lemon Candle",
  brandToken: "b_9vepscyv",
  brandName: "The Neighborgoods",
  imageUrl: "https://cdn.faire.com/fastly/ea4b916c89bd1431f2dabc81bb537a869a06bfa72952d72c3fee9d846851ecc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc55e20a833a7483875c80c5fab84181acaa27c9a7005fa8cd4909ae30698b18.jpeg",
    "https://cdn.faire.com/fastly/38e42f8b1a031f213fec767c246caedd9fc2313c6e17cb93c0b81c2e67643de8.jpeg",
    "https://cdn.faire.com/fastly/2b2fad30ff3bc7a09b511fc03c590222ee59aa9402522038734f70f650301809.jpeg",
    "https://cdn.faire.com/fastly/e05d74f5855deacbeff906dd9f1b70f53a16870637824e452f3873f45242f427.jpeg",
    "https://cdn.faire.com/fastly/04fff0e4a3b32c4df78c8a14c2addd5f5790a9a5a366a7b6d142f697ff60e0db.jpeg"
  ],
  priceDollars: 9,
  description: "For when you wish your kitchen smelled like you actually just finished zesting a lemon for a delicious homemade treat.\n\nA fresh lemon scent infuses this all-natural soy candle, which sits in a reusable, sardine tin container. The custom fragrance blend of lemon and vanilla delivers a fresh, mood-boosting scent when lit, and its clean, even burn makes it an easy go-to whenever you want a reset.\n\n• 4 oz. sardine-style rectangle tin\n• Approximately 24-hour burn time\n• 100% natural soy wax\n• Custom blended, paraben- and phthalate-free fragrance oils\n• Two lead-free cotton wicks for a clean, even burn\n• Sliding lid stores neatly under the candle when lit\n• Measures 4\" x 2.5\" x 7/8\"\n• Hand-poured locally in Washington, DC by District Candle Lab",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:39.154Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
